module.exports = __webpack_public_path__ + "static/media/team-page.0b76758f.svg";